import { render, staticRenderFns } from "./PartList.vue?vue&type=template&id=5231d030"
import script from "./PartList.vue?vue&type=script&lang=js"
export * from "./PartList.vue?vue&type=script&lang=js"
import style0 from "./PartList.vue?vue&type=style&index=0&id=5231d030&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports